(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-flavor-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-flavor-finder')) {
    customElements.define('cc-flavor-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.filters = {sweetness:'all', tartness:'all'};
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.resultsList = this.querySelector('.cc-lane__cards');
        this.guide = this.querySelector('[data-guide]');
        this.scrollUp = this.querySelector('[data-scroll-up]');
        this.scrollDown = this.querySelector('[data-scroll-down]');
        this.scrollUp?.addEventListener('click', () => this.scrollResults(-1));
        this.scrollDown?.addEventListener('click', () => this.scrollResults(1));
        this.resultsList?.addEventListener('scroll', () => this.updateScrollControls(), {passive:true});
        this.onLaneResize = () => this.updateScrollControls();
        window.addEventListener('resize', this.onLaneResize, {passive:true});
        this.selected = this.cards[0]?.dataset.card;
        this.querySelectorAll('[data-enhance]').forEach(el => el.hidden = false);
        this.querySelectorAll('[data-fallback]').forEach(el => el.hidden = true);
        this.classList.add('is-ready');
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-reset')) {
            this.filters = {sweetness:'all', tartness:'all'};
            this.apply();
            if (button.closest('[data-empty]')) this.querySelector('[data-value="all"]').focus();
          } else if (button.hasAttribute('data-value')) {
            const group = button.closest('[data-filter-group]').dataset.filterGroup;
            this.filters[group] = button.dataset.value;
            this.apply();
          } else if (button.dataset.select) {
            this.selected = button.dataset.select;
            this.showSelected();
            if (event.detail > 0 && window.matchMedia('(max-width:650px)').matches) {
              this.querySelector('[data-panel]:not([hidden])')?.scrollIntoView({block:'nearest', behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
            }
          }
        });
        this.apply();
      }
      apply() {
        const visible = this.cards.filter(card => {
          const match = Object.entries(this.filters).every(([key,value]) => value === 'all' || card.dataset[key] === value);
          card.hidden = !match;
          return match;
        });
        this.querySelectorAll('[data-filter-group]').forEach(group => {
          const key = group.dataset.filterGroup;
          const other = key === 'sweetness' ? 'tartness' : 'sweetness';
          group.querySelectorAll('[data-value]').forEach(button => {
            const value = button.dataset.value;
            button.setAttribute('aria-pressed', String(value === this.filters[key]));
            button.disabled = value !== 'all' && !this.cards.some(card => card.dataset[key] === value && (this.filters[other] === 'all' || card.dataset[other] === this.filters[other]));
            button.title = button.disabled ? this.dataset.unavailable : '';
          });
        });
        if (!visible.some(card => card.dataset.card === this.selected)) this.selected = visible[0]?.dataset.card;
        this.querySelector('[data-result-count]').textContent = visible.length === 1 ? this.dataset.one : this.dataset.count.replace('__COUNT__', String(visible.length));
        this.querySelector('[data-empty]').hidden = visible.length > 0;
        if (this.guide) this.guide.hidden = visible.length === 0 || visible.length % 2 === 0;
        if (this.resultsList) this.resultsList.scrollTop = 0;
        this.showSelected();
        window.requestAnimationFrame(() => this.updateScrollControls());
      }
      scrollResults(direction) {
        if (!this.resultsList) return;
        const firstVisible = this.cards.find(card => !card.hidden);
        const rowHeight = firstVisible ? firstVisible.getBoundingClientRect().height + 10 : 130;
        this.resultsList.scrollBy({
          top: direction * rowHeight * 2,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      updateScrollControls() {
        if (!this.resultsList || !this.scrollUp || !this.scrollDown) return;
        const maxScroll = this.resultsList.scrollHeight - this.resultsList.clientHeight;
        this.scrollUp.disabled = maxScroll <= 4 || this.resultsList.scrollTop <= 3;
        this.scrollDown.disabled = maxScroll <= 4 || this.resultsList.scrollTop >= maxScroll - 3;
      }
      disconnectedCallback() {
        if (this.onLaneResize) window.removeEventListener('resize', this.onLaneResize);
        this.initialized = false;
      }
      showSelected() {
        this.panels.forEach(panel => panel.hidden = panel.dataset.panel !== this.selected);
        this.cards.forEach(card => {
          const selected = card.dataset.card === this.selected;
          card.classList.toggle('is-selected', selected);
          card.querySelector('[data-select]').setAttribute('aria-pressed', String(selected));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-v5-tasting-flight"] && !Shopify.designMode) return;
  try {
    function initializeTastingBars(){document.querySelectorAll('[data-tasting-bar]').forEach(bar=>{if(bar.dataset.ready)return;bar.dataset.ready='true';const choices=Array.from(bar.querySelectorAll('[data-taste-choice]'));const panels=Array.from(bar.querySelectorAll('[data-taste-panel]'));const list=bar.querySelector('.cc-tasting__tabs');list.setAttribute('role','tablist');choices.forEach(choice=>{choice.setAttribute('role','tab');choice.id='tab-'+choice.dataset.tasteChoice;choice.setAttribute('aria-controls','taste-'+choice.dataset.tasteChoice);});panels.forEach(panel=>{panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby','tab-'+panel.dataset.tastePanel);});function select(choice,focus){choices.forEach(c=>{const active=c===choice;c.setAttribute('aria-selected',String(active));c.tabIndex=active?0:-1;});panels.forEach(p=>p.hidden=p.dataset.tastePanel!==choice.dataset.tasteChoice);if(focus)choice.focus();}select(choices[0],false);list.addEventListener('click',event=>{const choice=event.target.closest('[data-taste-choice]');if(!choice)return;event.preventDefault();select(choice,false);});list.addEventListener('keydown',event=>{const index=choices.indexOf(event.target);if(index<0)return;let target;if(event.key==='ArrowRight')target=(index+1)%choices.length;if(event.key==='ArrowLeft')target=(index-1+choices.length)%choices.length;if(event.key==='Home')target=0;if(event.key==='End')target=choices.length-1;if(target!==undefined){event.preventDefault();select(choices[target],true);}});});}initializeTastingBars();document.addEventListener('shopify:section:load',initializeTastingBars);
  } catch(e) { console.error(e); }
})();

})();
